import theme from "../../muiTheme";

const styles = {

    outerContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    innerContainer: {
        maxHeight: 'auto',
        overflowY: 'auto',
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            //maxHeight: '100vh'
        },
    }

}; 

export default styles; 
